import React,{Component} from 'react';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import Modal from 'react-modal';
import Alert from 'react-s-alert';
import firebase from 'firebase';
import ModalBases from './ModalBases';
import { Link } from 'react-router-dom';
import store from '../../store';
import { compose, withProps } from "recompose"
import { withScriptjs, withGoogleMap, GoogleMap, Marker } from "react-google-maps"
import Map from './mapa'
import { Provider as AlertProvider } from 'react-alert'
import AlertTemplate from 'react-alert-template-basic'


const database=firebase.database();


const options = {
	position: 'top right',
	timeout: 5000,
	offset: '30px',
	transition: 'scale',
	zIndex:100
  }

const customStyles = {
	content : {
	  top                   : '50%',
	  left                  : '50%',
	  transform             : 'translate(-50%, -50%)',
	  width                 : '450px',
	  height:'570px',
	  position:'relative'
	},
	overlay:{
		position: "fixed",
		top: 0,
		left: 0,
		right:0,
		bottom: 0,
		backgroundColor: "rgba(255, 255, 255, 0.75)",
		zIndex:1
	}
  };


  

class Bases extends Component{
	
	
	constructor(props){
		
		super(props);
		this.state={
			bases:[],
			baseKey:'',
			nombre:'',
			descripcion:'',
			foto:'',
			latitud:'',
			longitud:'',
			direccion:'',
			isActive:false,
			isActive2:false,
			uploadValue:0,
			files:null,
			template:true,
			coordenadas: { lat: -34.397, lng: 150.644 }
		}
		
		this.basesRef=database.ref().child('Bases');
		this.handleClick=this.handleClick.bind(this);
		this.toggleModal=this.toggleModal.bind(this);
		this.btnEditarFormatter=this.btnEditarFormatter.bind(this);
		this.btnInformacionFormatter=this.btnInformacionFormatter.bind(this);
		this.generateBtnVehiculos=this.generateBtnVehiculos.bind(this);
		
		this.ocultarMenu=this.ocultarMenu.bind(this);
		
		
			
	}
	
	componentWillMount = () =>{
		Modal.setAppElement('body');
	}

	
	componentDidMount(){
		this.basesRef.on('value', this.gotData, this.errData);	
		
	}
	
		
	//get the data from the firebase and push them out
	gotData = (data) => {
		
		
		  let newBase = [];
		  const basedata = data.val();
		  const keys = Object.keys(basedata);

		  for (let i = 0; i < keys.length; i++) {
			const k = keys[i];
			
			newBase.push({
			  key:k,
			  nombre:basedata[k].Nombre,
			  descripcion:basedata[k].Descripcion,
			  foto:basedata[k].foto,
			  latitud:basedata[k].latitud,
			  longitud:basedata[k].longitud,
			  direccion:basedata[k].direccion,
			  estado:basedata[k].estado
			});
		  }
		  this.setState({bases: newBase});
		}
		errData = (err) => {
			console.log(err);
		}
	

	
	
	
	handleClick(row){
		
		
		this.setState({
			
			baseKey: row.key,
			nombre:row.nombre,
			foto:row.foto,
			descripcion:row.descripcion,
			latitud:row.latitud,
			longitud:row.longitud,
			direccion:row.direccion,
			estado:row.estado
		});
		
		
		this.toggleModal();
	}
	
	toggleModal(){
		
		this.setState({
			files:null,
			isActive:!this.state.isActive,
			uploadValue:0
			
		});
		
	}
	toggleModal2(){
		
		this.setState({
			files:null,
			isActive2:!this.state.isActive2,
			uploadValue:0
		});
		
	}
	componentWillMount
	
	btnEditarFormatter(cell,row) {
		 
		return  <button className="btn btn-success btn-sm" onClick={() => {this.handleClick(row)}} >Editar</button>;
	}
	
	btnInformacionFormatter(cell,row) {
		 
		return  <button className="btn btn-info btn-sm" onClick={() => {this.handleClick(row)}} >Ver vehioulos</button>;
	}
 
	generateBtnVehiculos(cell,row){
		
		let url='/vehiculos_bases/'+row.key+'/'+row.nombre;
		
		return <Link to={url} className="btn btn-info btn-sm">Ver Vehiculos</Link>;
		
	}
	
	
	
	
 
 
	ocultarMenu(){
		

		store.dispatch({
			
			type: 'STATE_MOSTRAR',
			mostrar:'noMostrar'
		})
	}
	
	
	render(){
		
		return(
		
				<div className="bases container" onClick={this.ocultarMenu}>
				
					<h1 className="titulo">Bases</h1>
					<button className="btn btn-primary" onClick={()=>this.toggleModal2()}><span className="glyphicon glyphicon-plus"> </span> Nuevo</button>
					
					<Modal isOpen={this.state.isActive2} onRequestClose={()=>this.toggleModal2()}  style={customStyles} >
					
						<h3>Crear base</h3>
						
							<AlertProvider template={AlertTemplate} {...options}>
							<Map
							googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyCCZEbbK2GALcNzNprVpgav4lpvM4D6gGA&v=3.exp&libraries=geometry,drawing,places"
							loadingElement={<div style={{ height: `100%` }} />}
							containerElement={<div style={{ height: `300px`, marginTop:15, marginBottom:15  }} />}
							mapElement={<div style={{ height: `100%` }} />}
							showMarker={true}
							coordenadas={{ lat: this.state.latitud, lng: this.state.longitud }}
							baseKey=""
							nombre=""
							foto=""
							descripcion=""
							latitud=""
							longitud=""
							direccion=""
							guardar = {true}
							isActive2={this.state.isActive2}
							toggleModal = {() =>this.toggleModal2()}
							estado=""
							/>
							</AlertProvider>
					</Modal>
					
					<BootstrapTable data={ this.state.bases}
						 ref='table'
						 pagination={ true }
						 search={ true }
						 hover
						 >
						 <TableHeaderColumn dataField='key' isKey={true} dataSort={true} hidden >key</TableHeaderColumn>
						 <TableHeaderColumn dataField='nombre' dataSort={true}  >Nombre</TableHeaderColumn>
						 <TableHeaderColumn dataField='estado' dataSort={true}  >Estado</TableHeaderColumn>
						 <TableHeaderColumn dataField='descripcion' dataSort={true}  >Descripcion</TableHeaderColumn>
						 <TableHeaderColumn dataField='direccion' dataSort={true}  >Direccion</TableHeaderColumn>
						 <TableHeaderColumn dataField='info' dataAlign='center' dataFormat={ this.generateBtnVehiculos }>Vehiculos</TableHeaderColumn>
						 <TableHeaderColumn dataField='edit' dataAlign='center' dataFormat={ this.btnEditarFormatter.bind(this) }>Editar</TableHeaderColumn>
					</BootstrapTable>
				
					<Modal isOpen={this.state.isActive}  style={customStyles} onRequestClose={()=>this.toggleModal()} >
					
						<h3>Modificar Base</h3>
						
							<AlertProvider template={AlertTemplate} {...options}>
							<Map
							googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyCCZEbbK2GALcNzNprVpgav4lpvM4D6gGA&v=3.exp&libraries=geometry,drawing,places"
							loadingElement={<div style={{ height: `100%` }} />}
							containerElement={<div style={{ height: `300px` , marginTop:15, marginBottom:15 }} />}
							mapElement={<div style={{ height: `100%` }} />}
							showMarker={true}
							coordenadas={{ lat: this.state.latitud, lng: this.state.longitud }}
							baseKey={this.state.baseKey}
							nombre={this.state.nombre}
							foto={this.state.foto}
							descripcion={this.state.descripcion}
							latitud={this.state.latitud}
							longitud={this.state.longitud}
							direccion={this.state.direccion}
							guardar = {false}
							cerrar={this.toggleModal}
							toggleModal = {() =>this.toggleModal()}
							estado={this.state.estado}
							/>

							
							</AlertProvider>
					</Modal>
				
				</div>
		
		
		);
		
		
	}
	
}



export default Bases;


// WEBPACK FOOTER //
// ./src/Components/Bases/Bases.js